import axios from 'axios'
import get from 'just-safe-get'
import { parseResponseObject } from './utils'
import store from 'store'
import { i18n } from '@/i18n'

const options = {
  baseURL: process.env.FOLDAZ_API_BASE,
  headers: {
    Accept: 'application/json'
  }
}

const api = axios.create(options)

// Adds authorization token to requests
api.interceptors.request.use(config => {
  const { authToken } = store.state.currentUser
  if (authToken !== null) {
    config.headers.Authorization = `Bearer ${authToken}`
  }
  return config
})

// Adds current locale to requests
api.interceptors.request.use(config => {
  const currentLocale = i18n.locale || i18n.fallbackLocale
  config.headers['Content-Language'] = currentLocale
  return config
})

// Changes camelCase to kebab-case
api.interceptors.response.use(parseResponseObject)

// Handles unauthorized requests
api.interceptors.response.use((response) => {
  return response
}, (error) => {
  const statusCode = get(error, 'response.status')

  if (statusCode === 401) {
    store.dispatch('signOut')
  }

  return Promise.reject(error)
});

export default api



// WEBPACK FOOTER //
// ./src/api/foldaz.js